import { ThemeableStack, View, Text } from '@kit/ui/src'
import { createFileRoute, Outlet, redirect, useRouter, useLocation } from '@tanstack/react-router'
import { WebLayout } from '@web/app/components'
import { authSelectors } from '@web/app/features/auth/store/authSlice'
import { useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'

export const Route = createFileRoute('/_index')({
  // 1. EL BLOQUEO DE ENTRADA (Cubre clics y URL inicial)
  beforeLoad: ({ context, location }) => {
    if (!context.isAuthenticated) {
      throw redirect({ to: '/sign-in', search: { redirect: location.href } })
    }

    const isPasswordPending = context.userProfile?.password_created === false
    const isAtPasswordPage = location.pathname === '/cuenta/cambiarContrasena'

    if (isPasswordPending && !isAtPasswordPage) {
      throw redirect({ to: '/cuenta/cambiarContrasena', replace: true })
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  const router = useRouter()
  const location = useLocation()

  // 2. LEER DIRECTAMENTE DE REDUX (Para asegurar que sea instantáneo)
  const userProfile = useSelector(
    (state: any) => state.appApi.queries['getProfile(undefined)']?.data
  )
  const isPasswordPending = userProfile?.password_created === false
  const isAtPasswordPage = location.pathname === '/cuenta/cambiarContrasena'

  // 3. BLOQUEO DE NAVEGACIÓN ACTIVA
  useEffect(() => {
    if (isPasswordPending && !isAtPasswordPage) {
      router.navigate({ to: '/cuenta/cambiarContrasena', replace: true })
    }
  }, [isPasswordPending, isAtPasswordPage, router])

  useRedirectIfNotAuthenticated()

  // 4. EL MURO DE FUEGO
  if (isPasswordPending && !isAtPasswordPage) {
    return (
      <WebLayout>
        <ThemeableStack f={1} ai="center" jc="center">
          <View animation="lazy" enterStyle={{ opacity: 0 }}>
            <Text color="$color10">Redirigiendo a cambio de contraseña obligatorio...</Text>
          </View>
        </ThemeableStack>
      </WebLayout>
    )
  }

  return (
    <WebLayout bc={'yellow'}>
      <ThemeableStack padded ai={'center'}>
        <Outlet />
      </ThemeableStack>
    </WebLayout>
  )
}

function useRedirectIfNotAuthenticated() {
  const router = useRouter()
  const isAuthenticated = useSelector(authSelectors.isAuthenticated)

  useEffect(() => {
    if (!isAuthenticated) {
      router.invalidate()
    }
  }, [isAuthenticated, router])
}
